const INITIAL_STATE = {
  motivoList: [],
  motivo: null,
  motivoSelect: []
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'MOTIVOLIST_FETCH':
      return { ...state, motivoList: action.payload }
    case 'MOTIVO_SET':
      return { ...state, motivo: action.payload }
    case 'MOTIVO_SELECT':
      return { ...state, motivoSelect: action.payload }
    default:
      return state
  }
}